/**
 * Shared attributes for secure, client-only cookies.
 * Use when setting cookies via document.cookie so they work in modern browsers.
 */
export const SECURE_COOKIE_ATTRS = "path=/; Secure; SameSite=Lax";

export interface SetSecureCookieOptions {
  /** Expiration as a Date or number of days from now. Omit for session-like. */
  expires?: Date | number;
  /** Cookie path (default: /). */
  path?: string;
}

/**
 * Set a cookie with Secure and SameSite=Lax. Use for all client-only cookies.
 */
export function setSecureCookie(
  name: string,
  value: string,
  options: SetSecureCookieOptions = {}
): void {
  if (typeof document === "undefined") return;

  const path = options.path ?? "/";
  const attrs = path === "/" ? SECURE_COOKIE_ATTRS : `path=${path}; Secure; SameSite=Lax`;

  let expiresPart = "";
  if (options.expires !== undefined) {
    const exp =
      typeof options.expires === "number"
        ? new Date(Date.now() + options.expires * 24 * 60 * 60 * 1000)
        : options.expires;
    expiresPart = `expires=${exp.toUTCString()}; `;
  }

  document.cookie = `${name}=${value}; ${expiresPart}${attrs}`;
}
